import styled, { css } from 'styled-components';

export const StyledVehicleOffersListContainer = styled.div`
  padding: 20px 0px 30px 0px;
  height: auto;
  min-height: calc(100% - 36px);
`;

export const StyledConfigurationsWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - 400px);
`;

export const FilterWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 12px 0 0;
  width: 100%;
`;

export const SortingBox = styled.div<{ hide: boolean }>`
  justify-content: flex-end;
  ${({ hide }) =>
    hide &&
    css`
      display: ${hide ? 'none' : 'flex'};
    `};
`;

export const SortingContainer = styled.div`
  width: 300px;
`;
